// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1lEiC","signatureButtonsRight":"ModalSign_signatureButtonsRight__2klRe"};